import React from 'react'
import {Col, Row, Image} from 'react-bootstrap'
import {Link} from 'react-router'

import './Layout/BreederViewer.css'

const defaultAvatar = `${window.location.protocol}//${window.location.host}/default_avatar.png`

class BreederViewer extends React.Component {
  render () {
    const {breeder} = this.props
    return (
      <Link to={`/breeder/${breeder.key}`} className="BreederViewer">
        <div>
          <Row className="Cover" />
          <Row>
            <Col className="AvatarBox">
              <Image src={breeder.avatar ? breeder.avatar : defaultAvatar} alt={breeder.name} className="Avatar" />
            </Col>
          </Row>
          <Row>
            <Col className="InfoBox">
              <h3 className="Name">{breeder.name}</h3>
              <h4 className="HorseCount">پرورش‌دهنده <strong>{breeder.horseCount}</strong> راس اسب</h4>
            </Col>
          </Row>
        </div>
      </Link>
    )
  }
}

BreederViewer.propTypes = {
  breeder: React.PropTypes.object
}

export default BreederViewer



// WEBPACK FOOTER //
// ./src/components/Common/BreederViewer/BreederViewer.js